import { fitSpreadText } from '@kitup/book-schema';
/**
 * Производит блоки и выбирает наибольший допустимый кегль для конкретной сцены.
 * Сам замер живёт в `fitSpreadText`: по нему же api отказывает в тексте, который
 * сюда не поместится.
 */
export function prepareSpreadText(scene, attributes) {
    return fitSpreadText(scene, attributes);
}
//# sourceMappingURL=text.js.map